import { store } from "../redux/store";
export function pickInsurance(sum) {
    // Получение данных из store
    var _a = store.getState(), insurance = _a.insurance, selectedTariff = _a.selectedTariff;
    var tariff = selectedTariff.tariff;
    var insurances = insurance.insurance;
    if (!tariff || !insurances) {
        return null;
    }
    // Поиск подходящей страховки
    var foundInsurance = insurances.find(function (ins) {
        return (sum >= ins.sumCredFrom &&
            sum <= ins.sumCredTo &&
            tariff.insGrpTariff === ins.insGrpTariff);
    });
    // Возврат найденной страховки или null
    return foundInsurance || null;
}
